import React, { createContext, useState, useEffect, useContext } from 'react';

// Create a context for theme
export const ThemeContext = createContext();

// Create a provider component
export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  // Update body class and localStorage when theme changes
  useEffect(() => {
    document.body.className = theme;
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Listen for theme-changed events from any component
  useEffect(() => {
    const handleThemeChange = (event) => {
      setTheme(event.detail.theme);
    };
    
    document.addEventListener('theme-changed', handleThemeChange);
    
    return () => {
      document.removeEventListener('theme-changed', handleThemeChange);
    };
  }, []);

  // Toggle the theme
  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    
    // Dispatch event for other components
    document.dispatchEvent(new CustomEvent('theme-changed', { 
      detail: { theme: newTheme } 
    }));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme context
export const useTheme = () => useContext(ThemeContext); 